export default __webpack_public_path__ + "static/media/Countries.c29ee24d.svg";